module.exports = __webpack_public_path__ + "static/media/onboarding_tour_slide3.71cff778.png";